"use strict";
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoomAnimation = exports.ShakeAnimation = exports.PulseAnimation = exports.Animation = void 0;
var animation_1 = require("./animation");
Object.defineProperty(exports, "Animation", { enumerable: true, get: function () { return animation_1.Animation; } });
var pulseAnimation_1 = require("./pulseAnimation");
Object.defineProperty(exports, "PulseAnimation", { enumerable: true, get: function () { return pulseAnimation_1.PulseAnimation; } });
var shakeAnimation_1 = require("./shakeAnimation");
Object.defineProperty(exports, "ShakeAnimation", { enumerable: true, get: function () { return shakeAnimation_1.ShakeAnimation; } });
var zoomAnimation_1 = require("./zoomAnimation");
Object.defineProperty(exports, "ZoomAnimation", { enumerable: true, get: function () { return zoomAnimation_1.ZoomAnimation; } });
//# sourceMappingURL=index.js.map